import React from 'react';
import { Link } from 'react-router-dom';
import { getProfileUrl } from './urls';

// Extract unique, lowercased hashtags from text
export const extractHashtags = (text: string): string[] => {
  const tags = new Set<string>();
  const regex = /(^|\s)#([a-zA-Z0-9_]{2,30})/g; // allow letters, numbers, underscore
  let match: RegExpExecArray | null;
  while ((match = regex.exec(text)) !== null) {
    tags.add(match[2].toLowerCase());
  }
  return Array.from(tags);
};

// Extract unique, lowercased mentions from text (usernames)
export const extractMentions = (text: string): string[] => {
  const users = new Set<string>();
  const regex = /(^|\s)@([a-zA-Z0-9_]{2,30})/g;
  let match: RegExpExecArray | null;
  while ((match = regex.exec(text)) !== null) {
    users.add(match[2].toLowerCase());
  }
  return Array.from(users);
};

// Convert text to React nodes with clickable @mentions and #hashtags
export const renderTextWithLinks = (text: string): React.ReactNode => {
  if (!text) return null;
  const parts: React.ReactNode[] = [];
  const regex = /([#@][a-zA-Z0-9_]{2,30})/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(text)) !== null) {
    const start = match.index;
    const end = regex.lastIndex;
    const token = match[0];
    if (start > lastIndex) {
      parts.push(text.slice(lastIndex, start));
    }
    if (token.startsWith('#')) {
      const tag = token.slice(1).toLowerCase();
      parts.push(
        <Link key={`${start}-${tag}`} to={`/hashtag/${encodeURIComponent(tag)}`} style={{ color: '#0B6B6F', textDecoration: 'none', fontWeight: 600 }}>
          {token}
        </Link>
      );
    } else if (token.startsWith('@')) {
      const unameRaw = token.slice(1);
      const uname = unameRaw.toLowerCase();
      if (uname === 'followers') {
        // Special keyword: not a user link; render a subtle badge
        parts.push(
          <span key={`${start}-followers`} aria-label="tagged followers" style={{
            display: 'inline-block',
            padding: '2px 6px',
            borderRadius: 6,
            background: 'var(--color-primary-50)',
            color: 'var(--color-primary-700)',
            fontWeight: 700,
          }}>
            {token}
          </span>
        );
      } else {
        const to = getProfileUrl({ username: unameRaw });
        parts.push(
          <Link key={`${start}-${unameRaw}`} to={to} style={{ color: '#0B6B6F', textDecoration: 'none', fontWeight: 600 }}>
            {token}
          </Link>
        );
      }
    }
    lastIndex = end;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return <>{parts}</>;
};
